import { render } from "./ChatShowRedBag.vue?vue&type=template&id=67fbe3b0"
import script from "./ChatShowRedBag.vue?vue&type=script&lang=js"
export * from "./ChatShowRedBag.vue?vue&type=script&lang=js"

import "./ChatShowRedBag.vue?vue&type=style&index=0&id=67fbe3b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__